<div class="card-container">
  <div class="custom-card">
    <div class="icon">
      <mat-icon class="icon-display">money_off</mat-icon>
    </div>

    <div class="text-big">Your payment was canceled</div>
    <div class="text-small">
      Your payment was not processed. Don't worry you can try to pay again by going to your dashboard.
    </div>

    <button mat-raised-button color="primary" (click)="goToDashboard()">Continue to Dashboard</button>

  </div>
</div>
